import EditSelectedAd from './EditSelectedAd.component';

export default EditSelectedAd;